import React, {Component} from 'react'

import ServerErrorPage from './ServerErrorPage'
import NotFoundErrorPage from './NotFoundErrorPage'
import UnauthorizedErrorPage from './UnauthorizedErrorPage'
import {
  ServerError,
  AuthorizationError,
  ResourceNotFound
} from './errors'

class ErrorBoundary extends Component {
  constructor (props) {
    super(props)
    this.state = {
      errorName: null
    }
  }

  componentDidCatch (error, errorInfo) {
    // Catch errors in any components below and re-render with error message
    if (error.errorName === AuthorizationError.errorName) {
      this.setState({
        errorName: AuthorizationError.errorName
      })
    } else if (error.errorName === ServerError.errorName) {
      this.setState({
        errorName: ServerError.errorName
      })
    } else if (error.errorName === ResourceNotFound.errorName) {
      this.setState({
        errorName: ResourceNotFound.errorName
      })
    } else {
      this.setState({
        errorName: ServerError.errorName
      })
    }

    // You can also log error messages to an error reporting service here
  }

  render () {
    const { errorName } = this.state

    if (errorName === ServerError.errorName) {
      return <ServerErrorPage />
    } else if (errorName === AuthorizationError.errorName) {
      return <UnauthorizedErrorPage />
    } else if (errorName === ResourceNotFound.errorName) {
      return <NotFoundErrorPage />
    }
    return this.props.children
  }
}

export default ErrorBoundary



// WEBPACK FOOTER //
// ./src/components/error_handling/ErrorBoundary.js